export const dashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadata =
  "/dashboard/conversion_attribution_dashboard/:app_group_id/campaign_canvas_metadata";
